import { render, staticRenderFns } from "./sidebar-item.vue?vue&type=template&id=14428b0b"
import script from "./sidebar-item.vue?vue&type=script&lang=ts"
export * from "./sidebar-item.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\dev\\eatself\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('14428b0b')) {
      api.createRecord('14428b0b', component.options)
    } else {
      api.reload('14428b0b', component.options)
    }
    module.hot.accept("./sidebar-item.vue?vue&type=template&id=14428b0b", function () {
      api.rerender('14428b0b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "layout/sidebar-item.vue"
export default component.exports